import Dashboard from '../views/dashboard'
import DeliveryUserLogout from '../views/deliveryuserlogout';
import ChangeDefaultHub from '../views/changedefaulthub';

export default [
	{
		path: '/dashboard',
		name: 'Dashboard',
		component: Dashboard,
		title: 'Dashboard',
		meta: {
      requiresAuth: true
    }
	},
	{
		path: '/deliveryuserlogout',
		name: 'User Force Logout',
		component: DeliveryUserLogout,
		title: 'User Force Logout',
		meta: {
      requiresAuth: true
    }
	},
	{
		path: '/changedefaulthub',
		name: 'Change Default Hub',
		component: ChangeDefaultHub,
		title: 'Change Default Hub',
		meta: {
      requiresAuth: true
    }
	}
];



// WEBPACK FOOTER //
// ./src/modules/cargoallocation/router/index.js